import popMsg from './popMsg';

/**
 * @description 复制文字到粘贴板
 * @param {string} text 复制的文字
 */
const copy = (text: string): boolean => {
  let result = false;
  try {
    const textarea = document.createElement('textarea');
    textarea.style.opacity = '0';
    textarea.value = text;
    textarea.setAttribute('readonly', 'true');
    document.body.appendChild(textarea);
    textarea.select();
    if (document.execCommand('copy')) {
      popMsg('复制成功');
      result = true;
    } else {
      result = false;
    }
    textarea.remove();
  } catch {
    result = false;
  }
  return result;
};

export default copy;
